<template>
<div class="k-page-content">
	<div class="messageIndex">
		<div class="left box" v-loading="loading">
			<div class="title">
				<span class="t1">消息</span>
				<span class="t2" @click="gomore()">查看更多<i class="el-icon-arrow-right"></i></span>
			</div>
			<ul class="con" v-if="tableData.data.length > 0">
				<li v-for="(item,index) in tableData.data" :key="index" @click="goUrl(item)">
					<div :class="item.send_name_jian == '系统' ? 'name two' : 'name'">{{item.send_name_jian}}</div>
					<div class="content">
						<span class="read" v-if="item.is_read == 0"></span>
						<p class="t1">{{item.content}}</p>
						<p class="t2">
							<span>发件人：{{item.send_name}}</span>
							<span>{{item.send_time}}</span>
						</p>
					</div>
				</li>
			</ul>
			<ul class="con conNull" v-else>
				<img src="../assets/images/null_data.png" alt="">
				<p>暂无内容</p>
			</ul>
		</div>
		<div class="right box" v-loading="loading">
			<div class="title">
				<span class="t1">公告</span>
				<span class="t2" @click="gomoreNews()">查看更多<i class="el-icon-arrow-right"></i></span>
			</div>
			<ul class="notice" v-if="tableData2.data.length > 0">
				<li v-for="(item,index) in tableData2.data" :key="index" @click="goUrlNews(item)">
					<p>{{item.title}}</p>
					<span>{{item.create_time}}</span>
				</li>
			</ul>
			<ul class="notice conNull" v-else>
				<img src="../assets/images/null_data.png" alt="">
				<p>暂无内容</p>
			</ul>
		</div>
	</div>
</div>
</template>
<script>
export default {
  props: ['info'],
  data() {
      return {
		  loading:false,
		  tableData: {
		      data: []
		  },
		  tableData2: {
		      data: []
		  },
		  params:{
			  pagesize: 20,
			  page: 1,
		  }
      }
	},
	computed: {
		
	},
	mounted: function () {
		this.getMessage()
		this.getNews()
	},
	methods: {
		gomore(){
			this.$router.push('/Message')
		},
		gomoreNews(){
			this.$router.push('/news')
		},
		getMessage(){
			this.$api.get('/admin/news/message/list',this.params).then(res => {
			  if (res.code === 0) {
				  this.tableData.data = res.data.data;
				  this.tableData.data.forEach((item,index) => {
					  if(item.send_name != '系统'){
						  this.$set(this.tableData.data[index],'send_name_jian',item.send_name.charAt(0))
					  }else{
						  this.$set(this.tableData.data[index],'send_name_jian',item.send_name)
					  }
				  })
				  this.loading = false
			  } else {
				 this.$message.error(res.msg);
			  }
			  this.loading = false
			})
		},
		getNews(){
			this.loading = true
			this.$api.get('/admin/news/message/getnoticereadlist').then(res => {
			  if (res.code === 0) {
				  this.tableData2.data = res.data.readList;
				  this.loading = false
			  } else {
				 this.$message.error(res.msg);
			  }
			  this.loading = false
			})
		},
		goUrl(item){
			this.loading = true
			this.$api.get('/admin/news/message/info',{id:item.id}).then(res => {
			  if (res.code === 0) {
				  if(item.type == 2){
				  	this.$router.push({
				  		name: 'Checklist',
						query:{ type: item.status}
				  	});
				  }else{
					 this.$router.push({
					 	name: 'MessageDetail',
					 	query:{ id: item.id}
					 }); 
				  }
			  } else {
				 this.$message.error(res.msg);
			  }
			})
		},
		goUrlNews(item){
			this.$router.push({
				name: 'NewsDetail',
				query:{ id: item.id}
			}); 
		}
	}
}
</script>
<style lang="scss" scoped>
	.messageIndex{
		padding: 20px;
		box-sizing: border-box;
		display: flex;
		justify-content: space-between;
		.box{
			background-color: #fff;
			box-shadow: 0px 1px 4px 0px rgba(0,0,0,0.05);
			border-radius: 2px;
			min-height: calc(100vh - 110px);
			padding: 0 20px;
			box-sizing: border-box;
		}
		.left{
			width: 100%;
		}
		.right{
			width: 500px;
			margin-left: 20px;
		}
		.title{
			height: 52px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			border-bottom: 1px solid #E6E6E6;
			.t1{
				color: #262626;
				font-size: 16px;
				font-weight: 500;
				display: flex;
				position: relative;
				height: 52px;
				padding-left: 10px;
				align-items: center;
				&::before{
					content: "";
					display: inline-block;
					width: 3px;
					border-radius: 15px;
					height: 18px;
					margin-right: 6px;
					background-color: #2f88ff;
				}
			}
			.t2{
				font-size: 14px;
				color: #2f88ff;
				cursor: pointer;
			}
		}
		.con{
			padding: 10px 0;
			height: calc(100vh - 200px);
			overflow: auto;
			li{
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 10px 0;
				cursor: pointer;
				.name{
					width: 40px;
					height: 40px;
					background: #5E98FF;
					border-radius: 100%;
					display: inline-flex;
					align-items: center;
					justify-content: center;
					font-weight: 500;
					font-size: 20px;
					color: #FFFFFF;
					&.two{
						font-size: 14px;
					}
				}
				.content{
					flex: 1;
					margin-left: 10px;
					overflow: hidden;
					position: relative;
					.t1{
						font-weight: 500;
						font-size: 14px;
						color: #5A626B;
						line-height: 20px;
						height: 20px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						margin-bottom: 9px;
						width:calc(100% - 20px);
					}
					.t2{
						font-weight: 400;
						font-size: 13px;
						color: #AAAAAA;
						line-height: 18px;
						display: flex;
						justify-content: space-between;
					}
					.read{
						width: 10px;
						height: 10px;
						background: #FF5150;
						border-radius: 100%;
						position: absolute;
						right: 0;
						top: 4px;
					}
				}
			}
		}
		.notice{
			padding: 14px 0;
			li{
				display: flex;
				justify-content: space-between;
				height: 32px;
				align-items: center;
				cursor: pointer;
				p{
					font-weight: 500;
					font-size: 14px;
					color: #5A626B;
					height: 32px;
					line-height: 32px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					width:calc(100% - 80px);
					display: block;
				}
				span{
					font-weight: 500;
					font-size: 13px;
					color: #AAAAAA;
				}
			}
		}
	}
	.conNull{
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		p{
			margin-top: 20px;
			font-size: 14px;
		}
	}
</style>